import dayjs from 'dayjs'

export const getDayAppointments = (events, date) => {
    if (!date || !Array.isArray(events)) return []
    const dayStart = dayjs(date).startOf('day')
    const dayEnd = dayStart.add(1, 'day')

    return events
        .filter((event) => {
            if (!event || event.start == null) return false
            if (event.display === 'background' || event.display === 'none')
                return false
            const start = dayjs(event.start)
            if (!start.isValid() || start.valueOf() >= dayEnd.valueOf())
                return false
            const end = event.end ? dayjs(event.end) : start
            return end.isAfter(start)
                ? end.valueOf() > dayStart.valueOf()
                : start.valueOf() >= dayStart.valueOf()
        })
        .sort((a, b) => dayjs(a.start).valueOf() - dayjs(b.start).valueOf())
}
